import * as React from 'react'
import { useSnackbar } from 'notistack'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import { useDeleteNewsCommentMutation } from 'generated/graphql'
import Button from '@app.components/Button'
import useChannelError from '@app.feature/channel/hook/useChannelError'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

interface DeleteCommentModalProps extends IFModalProps {
  id: string
  onCompleted: () => void
}

const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({
  id,
  onClose,
  onCompleted,
  ...props
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const onError = useChannelError()

  const deleteNewsCommentMutation = useDeleteNewsCommentMutation({
    onCompleted: () => {
      onCompleted()
      enqueueSnackbar('댓글이 삭제되었습니다.')
    },
    onError: onError,
  })

  const handleConfirm = () => {
    const [mutate] = deleteNewsCommentMutation
    mutate({
      variables: {
        newsCommentId: id,
      },
    })
    onClose && onClose()
  }
  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-sub-title">댓글을 삭제하시겠어요?</div>
        <div className="btn-list">
          <Button color="grey" className="btn cancle" onClick={onClose}>
            취소
          </Button>
          <Button className="btn" onClick={handleConfirm}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default DeleteCommentModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-sub-title {
    font-size: 20px;
    margin: 20px 0 31px;
    width: 100%;
    text-align: center;
    font-weight: 500;
  }
  .btn-list {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    .btn {
      font-size: 16px;
      padding: 13px 30px;
      &.cancle {
        background-color: #bbbbbb;
      }
    }
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
